import React from 'react'
import {
  NOTI_PRIORITY_LOW,
  NOTI_PRIORITY_HIGH,
  NOTI_PRIORITY_URGENT,
  NOTI_PRIORITY_EMERGENCY,
} from 'app/constants/priority'
import Assets from 'app/configs/assetConfigs'
import { FormattedMessage } from 'react-intl'
import NotificationBadge from './NotificationBadge'

const NotificationImportantPreview = ({ priority }) => {
  switch (priority) {
    case NOTI_PRIORITY_LOW.label: {
      return (
        <NotificationBadge
          variant="info"
          isTextUpperCase={false}
          Icon={
            <img
              width={12}
              height={12}
              src={Assets.notiPriorityInPreview.informational}
              alt="informational"
            />
          }
        >
          <FormattedMessage id="createNotification.dialog.notiPriority.low" />
        </NotificationBadge>
      )
    }
    case NOTI_PRIORITY_HIGH.label: {
      return (
        <NotificationBadge
          variant="secondary"
          isTextUpperCase={false}
          Icon={
            <img
              width={12}
              height={12}
              src={Assets.notiPriorityInPreview.important}
              alt="important"
            />
          }
        >
          <FormattedMessage id="createNotification.dialog.notiPriority.high" />
        </NotificationBadge>
      )
    }
    case NOTI_PRIORITY_URGENT.label: {
      return (
        <NotificationBadge
          variant="warning"
          isTextUpperCase={false}
          Icon={
            <img
              width={12}
              height={12}
              src={Assets.notiPriorityInPreview.urgent}
              alt="urgent"
            />
          }
        >
          <FormattedMessage id="createNotification.dialog.notiPriority.urgent" />
        </NotificationBadge>
      )
    }
    case NOTI_PRIORITY_EMERGENCY.label: {
      return (
        <NotificationBadge
          variant="error"
          isTextUpperCase={false}
          Icon={
            <img
              width={12}
              height={12}
              src={Assets.notiPriorityInPreview.emergency}
              alt="emergency"
            />
          }
        >
          <FormattedMessage id="createNotification.dialog.notiPriority.emergency" />
        </NotificationBadge>
      )
    }
    default: {
      return null
    }
  }
}

export default NotificationImportantPreview
